import React from "react";

const PropertyImages = ({ state }) => {
  return (
    <div className="p-y-5 gap-y-4 w-full lg:w-[530px] flex flex-wrap justify-between items-center">
      {state?.properties_images?.map((item, index) => (
        <img
          key={index}
          src={item}
          alt="Property Image"
          className="w-full lg:w-[251px] object-cover h-[219px] rounded-[10px]"
        />
      ))}
    </div>
  );
};

export default PropertyImages;
